module.exports = __webpack_public_path__ + "media/images/empty_star-c6d497739878ba507c621beb896323c2.svg";